export const defaultStyle = {
    wrapper: "pt-[60px] md:pt-[75px] lg:pt-[90px] pb-[150px]",
    richTextWrapper: "section-wrapper",
    code: "",
    link: "",
    paragraph: "inline-block body-text [&_a]:underline mb-[16px]",
    heading1: "heading-text mb-[16px]",
    heading2: "heading-text mb-[16px]",
    heading3: "heading-text mb-[16px]",
    heading4: "heading-text mb-[16px]",
    heading5: "heading-text mb-[16px]",
    heading6: "heading-text mb-[16px]",
    table: "",
    tRow: "",
    tHeader: "",
    tData: "",
    ulList: "",
    list: "",
    title: "",
    mainLink: "",
}

export const TERMS_AND_CONDITIONS = {
    wrapper: "bg-offWhite text-mdlzPurple pt-[60px] md:pt-[75px] lg:pt-[90px] pb-[150px]",
    richTextWrapper: "section-wrapper",
    heading1: "heading-text mb-[16px]",
    heading2: "heading-text mb-[16px]",
    heading3: "heading-text mb-[16px]",
    heading4: "heading-text mb-[16px]",
    heading5: "heading-text mb-[16px]",
    heading6: "heading-text mb-[16px]",
    paragraph: "inline-block body-text [&_a]:underline mb-[16px]",
    ulList: "list-disc ml-[12px] body-text [&_a]:underline mb-[16px]",
    list: "list-disc ml-[12px] body-text [&_a]:underline",
}
export const COOKIES = {
    wrapper: "bg-offWhite text-mdlzPurple pt-[60px] md:pt-[75px] lg:pt-[90px]",
    richTextWrapper: "section-wrapper",
    heading1: "heading-text mb-[16px]",
    heading2: "heading-text mb-[16px]",
    heading3: "heading-text mb-[16px]",
    heading4: "heading-text mb-[16px]",
    heading5: "heading-text mb-[16px]",
    heading6: "heading-text mb-[16px]",
    paragraph: "inline-block body-text [&_a]:underline mb-[16px]",
    ulList: "list-disc ml-[12px] body-text [&_a]:underline mb-[16px]",
    list: "list-disc ml-[12px] body-text [&_a]:underline",
}
export const COOKIES_BOTTOM = {
    wrapper: "bg-offWhite text-mdlzPurple",
    richTextWrapper: "section-wrapper",
    heading1: "heading-text mb-[16px]",
    heading2: "heading-text mb-[16px]",
    heading3: "heading-text mb-[16px]",
    heading4: "heading-text mb-[16px]",
    heading5: "heading-text mb-[16px]",
    heading6: "heading-text mb-[16px]",
    paragraph: "inline-block body-text [&_a]:underline mb-[16px]",
    ulList: "list-disc ml-[12px] body-text [&_a]:underline mb-[16px]",
    list: "list-disc ml-[12px] body-text [&_a]:underline",
}
